<form (ngSubmit)="applyAlternativeDeviceAddress()">
   <div class="k-form-field sam-full-width alternative-device-editor">
      <div
         *ngIf="
            'CcoPermSetAlternativeDevice' | isFeatureEnabled$ | async;
            then changingDeviceAddressPossible;
            else changingDeviceAddressNotPossible
         "
      ></div>
      <ng-template #changingDeviceAddressPossible>
         <fa-icon
            [icon]="
               (isCurrentDeviceAddressAlternativeDevice$ | async) ? alternativeDeviceActiveIcon : (deviceIcon$ | async)
            "
         ></fa-icon>
         <input
            kendoTextBox
            samwebBlurOnEnter
            fxFlex="1 1 auto"
            [value]="deviceAddress$ | acdLineToDisplayNumber$ | async"
            (input)="changeDeviceAddressUnapplied($event.target.value)"
            (blur)="debounceResetAlternativeDeviceAddress()"
         />
         <fa-icon
            *ngIf="isUnappliedAlternativeDeviceAddress$ | async"
            [icon]="applyAlternativeDeviceIcon"
            (click)="applyAlternativeDeviceAddress()"
            class="apply-button sam-clickable sam-margin-right"
         ></fa-icon>
         <fa-icon
            *ngIf="(isCurrentDeviceAddressAlternativeDevice$ | async) || (isUnappliedAlternativeDeviceAddress$ | async)"
            [icon]="resetAlternativeDeviceIcon"
            (click)="resetAlternativeDeviceAddress()"
            class="reset-button sam-clickable"
         ></fa-icon>
      </ng-template>
      <ng-template #changingDeviceAddressNotPossible>
         <fa-icon [icon]="deviceIcon$ | async"></fa-icon>
         <div class="device-address">
            {{ deviceAddress$ | acdLineToDisplayNumber$ | async }}
         </div>
      </ng-template>
   </div>
</form>
